import { FIT_DATA_TYPE_META } from "../../../lib/utils/consts";
import { cloneDeep } from "lodash-es";
/** 取自designer 和SettleComponent.vue 的可替换列表默认生成逻辑
 * 当组件内部设置了binging时会使用下面的逻辑 通过fitData生成类型兼容的可替换列表
 * */
export function loadDesignerDefaultReplaceComponentHook(uc) {
  uc.hooks.getReplaceComponent.tap('designerDefaultHook', (result, ctx) => {
    const {
      designer,
      layout,
      meta,
      path
    } = ctx;
    const mainBindingId = meta === null || meta === void 0 ? void 0 : meta.mainBindingId;
    const mainBindingDataPath = mainBindingId && layout.bindings && layout.bindings[mainBindingId];
    if (mainBindingDataPath) {
      const sortedAlternates = designer.uc.fitData(mainBindingDataPath, designer.renderer, {
        compTypeFilter: 'all',
        requestSource: 'replaceComponent'
      }).map(x => {
        var _FIT_DATA_TYPE_META$x;
        return {
          ...x,
          typeCName: ((_FIT_DATA_TYPE_META$x = FIT_DATA_TYPE_META[x.type]) === null || _FIT_DATA_TYPE_META$x === void 0 ? void 0 : _FIT_DATA_TYPE_META$x.name) || x.type
        };
      });
      const applyCallback = item => {
        const layout = cloneDeep(item.layout);
        designer.uc.completeLayout(layout);
        designer.replaceCompWith(path, layout);
      };
      const callbacks = sortedAlternates.map(item => ({
        ...item,
        applyCallback,
        from: 'designerDefaultHook'
      }));
      return [...result, ...callbacks];
    }
    return result;
  });
}